const STATUS_COLORS = {
  draft: 'gray',
  pending: 'amber',
  approved: 'blue',
  ordered: 'green',
  received: 'teal',
  cancelled: 'red',
};

const StatusBadge = ({ status, customColor }) => {
  const color = customColor || STATUS_COLORS[status?.toLowerCase()] || 'gray';
  return (
    <span className={`home-status-badge home-status-${color}`}>
      <span className={`home-status-dot home-dot-${color}`} />
      {status?.replace(/_/g, ' ') || '—'}
    </span>
  );
};

export default StatusBadge;
